import React from 'react';

const HeroSection = ({ 
  name = "Yomuma Likessa",
  tagline = "Empower Startups. Strengthen Ecosystems.",
  mainHeading = "We help NGOs, accelerators, and ecosystem partners deliver high-impact coaching, training, and business-diagnosis programs—and design the next generation of startup-support initiatives across Ethiopia and East Africa.",
  primaryButtonText = "Grow Your Business",
  secondaryButtonText = "Get More Leads",
  freeTrainingText = "Free Training",
  imageSrc = "/Herro_logo.png",
  navigationItems = [
    { label: "Accelerators", hasDropdown: false },
    { label: "KPI Score", hasDropdown: false },
    { label: "ScoreApp", hasDropdown: false },
    { label: "Books", hasDropdown: true }
  ],
  onPrimaryButtonClick = () => console.log("Primary button clicked"),
  onSecondaryButtonClick = () => console.log("Secondary button clicked"),
  onFreeTrainingClick = () => console.log("Free training clicked"),
  onNavItemClick = (item) => console.log(`Navigation clicked: ${item}`)
}) => {
  return (
    <div className="bg-hero-bg flex flex-col overflow-visible" style={{ minHeight: '100vh' }}>
      {/* Navigation Bar */}
      <nav className="flex items-center justify-between px-4 sm:px-6 py-4 lg:px-12 z-20 relative mx-4 sm:mx-6 md:mx-8 lg:mx-24 xl:mx-24">
        {/* Left - Name */}
        <div className="text-text-white font-bold text-base sm:text-lg lg:text-xl">
          {name}
        </div>
        
        {/* Center - Navigation Links */}
        <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
          {navigationItems.map((item, index) => (
            <a
              key={index}
              href={item.target ? `#${item.target}` : '#'}
              onClick={() => onNavItemClick(item.label)}
              className="text-text-white hover:text-accent-yellow transition-colors duration-200 flex items-center space-x-1 text-sm lg:text-base"
            >
              <span>{item.label}</span>
            </a>
          ))}
        </div>
        
        {/* Right - Free Training Button */}
        <button
          onClick={onFreeTrainingClick}
          className="bg-accent-yellow text-black px-3 sm:px-4 py-2 rounded font-semibold hover:bg-yellow-400 transition-colors duration-200 text-sm sm:text-base"
        >
          {freeTrainingText}
        </button>
      </nav>

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col lg:flex-row items-center lg:items-center lg:justify-start gap-0 lg:gap-4 px-4 sm:px-6 py-8 sm:py-10 lg:pt-0 lg:pb-8 xl:pt-0 xl:pb-8 relative z-10 overflow-visible mx-4 sm:mx-6 md:mx-8 lg:mx-24 xl:mx-24">
        {/* Left Side - Text Content */}
        <div className="w-full lg:flex-1 mt-6 sm:mt-8 lg:mt-0 mb-8 sm:mb-6 lg:mb-0 lg:pr-0 text-center lg:text-left lg:self-center">
          {/* Tagline */}
          <div className="text-accent-yellow font-semibold text-base sm:text-lg lg:text-xl mb-3 sm:mb-4">
            {tagline}
          </div>
          
          {/* Main Heading */}
          <h1 className="text-text-white text-2xl sm:text-3xl lg:text-4xl xl:text-5xl 2xl:text-6xl font-bold leading-tight mb-6 sm:mb-4 lg:mb-8">
            {mainHeading}
          </h1>
        </div>
        
        {/* Right Side - Image */}
        <div className="flex-shrink-0 flex justify-center lg:justify-end items-center w-full lg:w-auto lg:ml-0 mt-6 sm:mt-6 lg:-mt-4 xl:-mt-6 lg:self-center">
          <div className="relative flex items-center justify-center" style={{ maxWidth: '100%' }}>
            <img
              src={imageSrc}
              alt={name}
              className="rounded-lg w-full max-w-[420px] sm:max-w-[500px] md:max-w-[580px] lg:max-w-[630px] xl:max-w-[650px]"
              style={{
                display: 'block',
                objectFit: 'contain'
              }}
            />
            {/* Polo logo simulation */}
            {/* <div className="absolute top-3 sm:top-4 left-3 sm:left-4 w-6 sm:w-8 h-6 sm:h-8 bg-polo-red rounded-full flex items-center justify-center">
              <span className="text-white text-xs font-bold">YL</span>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
